import { apiBasePath } from '../BaseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getBillingPlan: build.query({
      query: () => ({
        url: `${apiUrl.billingPlan}`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      }),
    }),
    getCurrentSubscription: build.query({
      query: () => ({
        url: `${apiUrl.currentSubscription}`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      }),
    }),
    getAddonPlans: build.query({
      query: () => ({
        url: `${apiUrl.settings}addon-plans/`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      }),
    }),
    createOrder: build.mutation({
      query: ({ planId, billingCycle, paymentType }) => ({
        url: `${apiUrl.createOrder}`,
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`,
          'Content-Type': 'application/json'
        },
        body: {
          plan_id: planId,
          billing_cycle: billingCycle,
          payment_type: paymentType
        }
      }),
    }),
    paymentSuccess: build.mutation({
      query: (paymentData) => ({
        url: `${apiUrl.paymentSuccess}`,
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`,
          'Content-Type': 'application/json'
        },
        body: paymentData
      }),
    }),
    planFeatureCredits: build.query({
      query: (planId) => ({
        url: `${apiUrl.settings}plan-feature-credits/${planId}/`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      })
    }),
    creditHistory: build.query({
      query: () => ({
        url: `${apiUrl.settings}credit-history/`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      })
    }),
    billingHistory: build.query({
      query: () => ({
        url: `${apiUrl.settings}billing-history/`,
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`
        }
      })
    }),
    customAddonPayment: build.mutation({
      query: ({ FeatureCode, credits }) => ({
        url: `${apiUrl.settings}custom_addon_payment/`,
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`,
          'Content-Type': 'application/json'
        },
        body: {
          feature_code: FeatureCode,
          credits,
        }
      }),
    }),
    customAddonPaymentSuccess: build.mutation({
      query: (paymentData) => ({
        url: `${apiUrl.settings}custom_addon_payment_success/`,
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${JSON.parse(localStorage.getItem("globalUser")).access}`,
          'Content-Type': 'application/json'
        },
        body: paymentData
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBillingPlanQuery,
  useGetCurrentSubscriptionQuery,
  useGetAddonPlansQuery,
  useCreateOrderMutation,
  usePaymentSuccessMutation,
  usePlanFeatureCreditsQuery,
  useCreditHistoryQuery,
  useBillingHistoryQuery,
  useCustomAddonPaymentMutation,
  useCustomAddonPaymentSuccessMutation,
} = extendedApi;